import { render, staticRenderFns } from "./VOTD.vue?vue&type=template&id=b1f7c1b0&scoped=true&"
import script from "./VOTD.vue?vue&type=script&lang=js&"
export * from "./VOTD.vue?vue&type=script&lang=js&"
import style0 from "./VOTD.vue?vue&type=style&index=0&id=b1f7c1b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f7c1b0",
  null
  
)

export default component.exports